









































import { Result, ScoreCriteriaDetail } from '@empathybroker/tsclient-search';

import { ColorEnum, ScoreCriteriaDetailTypeEnum } from '../../enums';

import { Dictionary, ExplainScoreCriteriaMessages } from '../../models';

import { ExplainUtils } from '../../utils';

import Badge from '../badge.component.vue';
import ExplainResultsRow from './explain-results-row.component.vue';

export default {
  name: 'explain-results-score-row',
  props: {
    results: {
      type: Array,
      required: true
    },
    criteriaDetailType: String,
    level: {
      type: Number,
      default: 0
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    ExplainResultsRow,
    Badge
  },
  computed: {
    resultIds: function (): string[] {
      return this.results.map((result) => result.id);
    },
    color: function (): ColorEnum {
      if (!this.criteriaDetailType) {
        return ColorEnum.PRIMARY;
      }
    },
    criteriaDetailMessages: function (): ExplainScoreCriteriaMessages {
      return ExplainUtils.getResultScoreCriteriaDetailMessages(this.criteriaDetailType, this.messages);
    },
    criteriaDetailText: function (): string {
      if (!!this.criteriaDetailType) {
        return ((this.results.length === 1) ? this.criteriaDetailMessages.label : this.criteriaDetailMessages.abbr);
      }
      return this.messages.total;
    },
    criteriaDetailIcon: function (): string {
      return ExplainUtils.getResultScoreCriteriaDetailIcon(this.criteriaDetailType);
    },
    criteriaInnerDetailTypes: function (): ScoreCriteriaDetailTypeEnum[] {
      return this.results.reduce((criteriaDetailTypes: ScoreCriteriaDetailTypeEnum[], result: Result) => {
        const resultScoreCriteriaDetail = this.getResultScoreCriteriaDetail(result);
        if (!!resultScoreCriteriaDetail && !!resultScoreCriteriaDetail.details) {
          Object.keys(resultScoreCriteriaDetail.details).forEach((criteriaDetailType: ScoreCriteriaDetailTypeEnum) => {
            if (!criteriaDetailTypes.includes(criteriaDetailType) &&
              Object.values(ScoreCriteriaDetailTypeEnum).includes(criteriaDetailType)) {
              criteriaDetailTypes.push(criteriaDetailType);
            }
          });
        }
        return criteriaDetailTypes;
      }, []);
    }
  },
  data: function () {
    return {
      childrenExpanded: false,
      ColorEnum
    };
  },
  methods: {
    getResultScoreCriteriaDetail(result: Result): (ScoreCriteriaDetail | Dictionary) {
      const resultScoreCriteria = ExplainUtils.getResultScoreCriteria(result);
      return ExplainUtils.findScoreCriteriaDetail(this.criteriaDetailType, resultScoreCriteria.details);
    },
    getResultCriteriaDetailValue: function (result: Result): number {
      const resultScoreCriteriaDetail = this.getResultScoreCriteriaDetail(result);
      if (!!resultScoreCriteriaDetail) {
        return resultScoreCriteriaDetail.value;
      }
    },
    getResultTotalScoreValue: function (result: Result): number {
      return Number(ExplainUtils.getResultScoreCriteria(result).value);
    },
    getResultCriteriaDetailValueText: function (result: Result): string {
      const criteriaDetailValue = (!!this.criteriaDetailType ? this.getResultCriteriaDetailValue(result) :
        this.getResultTotalScoreValue(result));
      if (!!criteriaDetailValue) {
        return criteriaDetailValue.toLocaleString(this.$epb.locale);
      }
      return '-';
    }
  }
};
